/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useAddActivityLog
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for add activity log
 *
 */
interface IProps {
	entityType: ClaimWorkLists.IWorkListEntityType;
	entityId: string;
	model: ClaimRequest.IActivityLogPostModel;
}
const useAddActivityLog = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ entityType, entityId, model }) => {
			const { data } = await api.ActivityLogApi.createActivityLog({ entityType, entityId, activityLogPost: model });
			return data;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimActivityLogs] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useAddActivityLog;
